<template>
  <span class="badge">
    <svg
      aria-hidden="true"
      class="badge-corner badge-corner--tl"
      viewBox="0 0 11 10"
    >
      <path
        d="M 0 0 L 11 0 L 11 10 L 10 10 A 10 10 0 0 0 0 0 Z"
        fill="#d6f1f4"
      />
    </svg>
    <img :src="Fingerprint" alt="" />
    <span>Registered for protection</span>
    <svg
      aria-hidden="true"
      class="badge-corner badge-corner--br"
      viewBox="0 0 10 11"
    >
      <path d="M 0 0 L 10 0 L 10 11 A 10 10 0 0 0 0 1 L 0 0 Z" fill="#def0ec" />
    </svg>
  </span>
</template>

<script setup lang="ts">
import Fingerprint from '@/assets/images/Fingerprint.png'
</script>

<style scoped>
.badge {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  box-sizing: border-box;
  width: 177px;
  height: 27px;
  padding: 0 10px 1px;
  border-radius: 0 10px 0 10px;
  background: linear-gradient(90deg, #d6f1f4 0%, #def0ec 100%);
  color: #1a1d21;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  white-space: nowrap;
}

.badge img {
  display: block;
  width: 14px;
  height: 16px;
}

.badge-corner {
  position: absolute;
  display: block;
  pointer-events: none;
}

.badge-corner--tl {
  top: 0;
  right: 100%;
  width: 11px;
  height: 10px;
  margin-right: -1px;
}

.badge-corner--br {
  top: 100%;
  right: 0;
  width: 10px;
  height: 11px;
  margin-top: -1px;
}
</style>
